var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1995 7.84717H15.6841V16.1723C15.6841 16.425 15.8807 16.6228 16.1345 16.6228H16.8936C17.2869 15.4978 18.3558 14.7101 19.6214 14.7101C20.887 14.7101 21.9559 15.5253 22.3492 16.6228H23.0808C23.1929 16.6228 23.25 16.5382 23.25 16.4261V13.9236L18.8338 13.9225C18.2153 13.9225 17.7088 13.416 17.7088 12.7975V10.5762C17.7088 9.9577 18.2153 9.45125 18.8338 9.45125H20.1839L19.3402 7.93302C19.3116 7.87589 19.2556 7.84717 19.1995 7.84717Z",
    fill: "#082645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1932 16.5941C14.5305 16.5941 14.7843 16.3128 14.7843 16.003L14.7832 8.15709V5.09105C14.7832 4.75379 14.502 4.5 14.1921 4.5L1.34105 4.5011C1.00379 4.5011 0.75 4.78233 0.75 5.09214V16.0033C0.75 16.3405 1.03124 16.5943 1.34105 16.5943H2.2968C2.69008 15.4694 3.759 14.6817 5.02457 14.6817C6.29013 14.6817 7.35905 15.4968 7.75234 16.5943L14.1932 16.5941Z",
    fill: "#082645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6083 10.5748V12.7961C18.6083 12.9082 18.7204 13.0214 18.8336 13.0214H22.8828L20.8856 10.3496H18.8609C18.7203 10.3496 18.6083 10.4342 18.6083 10.5748Z",
    fill: "#082645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99709 15.4404C3.84357 15.4404 2.88782 16.3962 2.88782 17.5497C2.88782 18.7032 3.84357 19.659 4.99709 19.659C6.15061 19.659 7.10636 18.7032 7.10636 17.5497C7.10636 16.3962 6.17806 15.4404 4.99709 15.4404Z",
    fill: "#082645"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7046 19.659C20.8581 19.659 21.8139 18.7032 21.8139 17.5497C21.8139 16.3962 20.8581 15.4404 19.7046 15.4404C18.5511 15.4404 17.5953 16.3962 17.5953 17.5497C17.5953 18.7032 18.5236 19.659 19.7046 19.659Z",
    fill: "#082645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleBlack);
export default __webpack_public_path__ + "static/media/vehicleBlack.f0f2899d11b65186d0b9a1e37c39021c.svg";
export { ForwardRef as ReactComponent };